const TAG = "C2C";

export const logger = {
  info: (category, msg) => {},
};
